import { Router} from '@angular/router';
import {Observable, forkJoin} from 'rxjs';
import {Injectable, inject, signal, Injector, linkedSignal} from '@angular/core';
import { UserProfileResponse, Client, LoginRequest } from '../../../api/client';
import { NzMessageService } from 'ng-zorro-antd/message';
import {BasketUiServiceService} from '../../pages/basket/basket-ui-service.service';
import {WishListService} from '../wishlist.service';
import {JwtService} from './jwt-service.service';


@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private router = inject(Router);
  private client = inject(Client);
  private injector = inject(Injector);
  private notify: NzMessageService = inject(NzMessageService);
  private jwtService = inject(JwtService);
  isAuth = linkedSignal<boolean>(() => this.jwtService.isTokenValid());
  errorMessage = signal<string>(null)
  profile = signal<UserProfileResponse | null>(null);

  constructor() {
    this.getProfileInfo()
  }


  login(loginRequest: LoginRequest) {
    this.loginAccount(loginRequest).subscribe({
      next: (data) => {
        if (data && data.accessToken) {
          this.jwtService.setTokens(data.accessToken.token, data.refreshToken);
          this.getProfileInfo();
          this.migrateRecentlyViewed();
          const wishListService = this.injector.get(WishListService);
          wishListService.initWishList();
          const basketService = this.injector.get(BasketUiServiceService);
          basketService.initBasket()
          this.router.navigate(['/account/profile']);
          this.notify.success('Вход выполнен успешно');
          this.isAuth.set(true)
        }
      },
      error: (error) => {
          this.errorMessage.set(error.message);
      },
    });
  }

  getProfileInfo(): void {
    if (!this.isAuthenticated()) return;
    this.getProfileData().subscribe({
      next: (data) => {
        this.profile.set(data);
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  migrateRecentlyViewed() {
    this.client.recentlyViewedProducts_GetProductsByCookie(1, 16)
      .subscribe({
        next: (products) => {
          if (!products || products.items.length === 0) {
            return;
          }
          const requests = products.items.map(p =>
            this.client.recentlyViewedProducts_CreateByUser(p.id)
          );
          forkJoin(requests).subscribe({
            next: () => {
              window.dispatchEvent(new Event('recentlyViewedUpdated'));
            },
            error: (err) => console.error('Ошибка миграции', err)
          });
        },
        error: (err) => console.error('Ошибка получения cookie-продуктов', err)
      });
  }

  logout() {
    this.jwtService.clearTokens()
    this.isAuth.set(false);
    this.profile.set(null)
    const basketService = this.injector.get(BasketUiServiceService);
    basketService.countBasket.set(0)
    const wishListService = this.injector.get(WishListService);
    wishListService.countWish.set(0)
    this.router.navigate(['/']);
  }

  public isAuthenticated(): boolean {
    return this.jwtService.isTokenValid();
  }

  public authToast(messageTrue: string): boolean {
    if (!this.isAuthenticated()) {
      this.notify.error('Необходимо авторизоваться');
      return false;
    } else {
      this.notify.success(messageTrue);
      return true;
    }
  }

  getRegInfo(): Observable<any> {
    return this.client.account_GetRegisterInfo();
  }

  loginAccount(loginRequest: LoginRequest) {
    return this.client.account_Login(loginRequest);
  }

  getProfileData() {
    return this.client.profile_GetProfileInfo();
  }
}
